import React from "react";
import styled from "@emotion/styled";

export default function SmsMarketingConsent({ checked, onChange }) {
    return (
        <ConsentLabel>
            <input
                type="checkbox"
                name="smsMarketingConsent"
                checked={checked === true}
                onChange={(event) => onChange(event.target.checked)}
            />
            <span>
                I agree to receive SMS marketing messages.
                <small>Optional. You can change this preference in your account.</small>
            </span>
        </ConsentLabel>
    );
}

const ConsentLabel = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    margin: 16px 0;
    color: #444444;
    font-size: 15px;
    line-height: 1.5;
    cursor: pointer;
    input { width: 22px; height: 22px; margin: 2px 0 0; flex-shrink: 0; }
    small { display: block; margin-top: 4px; color: #666666; font-size: 12px; }
`;
